export var MAX_DAYS_IN_CALENDAR = 42;